export type SocialIconList = 'instagram' | 'facebook' | 'linkedin' | 'youtube'
export type IconList =
  | 'chevron'
  | 'user'
  | 'phone'
  | 'paper'
  | 'marker'
  | 'mail'
  | 'key'
  | 'house'
  | 'pen-note'
  | 'fingerprint'
export type ButtonIconList =
  | 'bolt'
  | 'arrowleft'
  | 'arrowright'
  | 'upload'
  | 'plus'
export type SvgList = SocialIconList | IconList | ButtonIconList

export type SVGProps = {
  id?: SvgList
  className?: string
  width?: number
  height?: number
  constrain?: boolean
} & React.SVGAttributes<SVGElement>

type SVGItem = {
  width: number
  height: number
  paths: Array<string>
}

const svgs: Record<string, SVGItem | undefined> = {
  upload: {
    width: 22,
    height: 22,
    paths: ['M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z'],
  },
  facebook: {
    width: 12,
    height: 22,
    paths: [
      'M7.8 22V12h3.5l.5-3.9h-4V5.6c0-1.1.3-1.9 2-1.9H12V.2C11.6.1 10.3 0 8.8 0 5.7 0 3.5 1.8 3.5 5.2v2.9H0V12h3.5v10h4.3z',
    ],
  },
  twitter: {
    width: 21,
    height: 17,
    paths: [
      'M6.43904 16.6115C14.1657 16.6115 18.3911 10.2213 18.3911 4.67984C18.3911 4.49833 18.3874 4.31765 18.3793 4.13778C19.1995 3.54585 19.9124 2.80716 20.4747 1.96627C19.722 2.30025 18.912 2.52509 18.0623 2.62647C18.9296 2.1073 19.5954 1.28604 19.9096 0.307003C19.0979 0.787336 18.1991 1.13645 17.2421 1.32493C16.4756 0.50982 15.3842 0 14.1758 0C11.8561 0 9.97488 1.87803 9.97488 4.19296C9.97488 4.52204 10.0117 4.84213 10.0838 5.14916C6.59251 4.97378 3.49669 3.30508 1.42479 0.767713C1.06403 1.38744 0.856008 2.10732 0.856008 2.87544C0.856008 4.33035 1.59762 5.61474 2.72536 6.36613C2.03617 6.34487 1.38875 6.15601 0.822892 5.84164C0.822274 5.85924 0.822274 5.87639 0.822274 5.8952C0.822274 7.92611 2.27025 9.62176 4.19237 10.006C3.83939 10.1021 3.468 10.1536 3.08469 10.1536C2.81443 10.1536 2.55112 10.127 2.29519 10.0779C2.82999 11.7442 4.38076 12.9567 6.21934 12.9906C4.78159 14.1155 2.97044 14.7856 1.00201 14.7856C0.663357 14.7856 0.328806 14.7664 0 14.7275C1.85912 15.9171 4.06664 16.6113 6.43926 16.6113',
    ],
  },
  instagram: {
    width: 16,
    height: 16,
    paths: [
      'M8 5.4C6.5 5.4 5.4 6.5 5.4 8s1.2 2.6 2.6 2.6 2.6-1.2 2.6-2.6S9.5 5.4 8 5.4z',
      'M11.6 0H4.4C2 0 0 2 0 4.4v7.3C0 14 2 16 4.4 16h7.3c2.4 0 4.4-2 4.4-4.4V4.4C16 2 14 0 11.6 0zM8 12.4c-2.4 0-4.4-2-4.4-4.4 0-2.4 2-4.4 4.4-4.4 2.4 0 4.4 2 4.4 4.4 0 2.4-2 4.4-4.4 4.4zm5.3-8.9c-.5 0-.9-.4-.9-.9s.4-.9.9-.9.9.4.9.9-.4.9-.9.9z',
    ],
  },
  youtube: {
    width: 20,
    height: 14,
    paths: [
      'M19.7 2.3c0-.1 0-.2-.1-.3v-.1c-.3-.8-.9-1.3-1.8-1.3h.2S14.6.1 10.1.1 2.2.6 2.2.6h.2C1.5.6.8 1.1.6 1.9V2c0 .1 0 .2-.1.3C.3 3.1 0 4.9 0 7s.3 3.9.3 4.7c0 .1 0 .2.1.3v.1c.3.8.9 1.3 1.8 1.3h-.1s3.4.5 7.9.5 7.9-.5 7.9-.5h-.2c.9 0 1.6-.5 1.8-1.3V12c0-.1 0-.2.1-.3.1-.8.4-2.6.4-4.7s-.2-3.9-.3-4.7zm-6.8 5.1-4.1 2.9c-.1.1-.2.1-.3.1-.1 0-.2 0-.3-.1-.2-.1-.3-.3-.3-.4V4.1c0-.2.1-.3.3-.4.2-.1.3-.1.5 0l4.1 2.9c.2.1.3.2.3.4.1.2 0 .3-.2.4z',
    ],
  },
  user: {
    width: 20,
    height: 21,
    paths: [
      'M11.9452107 10.0079921 C10.3458852 10.5099783 9.72432822 10.5304768 8.31835316 10.1566219 C7.98624197 10.0685526 7.345698 10.0839062 7.05336229 10.1508023 C2.80292245 11.1372604 0.215041667 14.7393056 0.215041667 19.4168636 C0.215041667 19.8001764 0.525778097 20.1109129 0.909090909 20.1109129 L18.9534394 20.1109129 C19.3367522 20.1109129 19.6474886 19.8001764 19.6474886 19.4168636 C19.6474886 15.2123388 16.9527622 11.5279751 13.0376247 10.2077953 L12.9077864 10.1648103 L12.8528187 10.1397704 L12.7638463 10.097698 C12.4768754 9.96528327 12.2475831 9.91309857 11.9452107 10.0079921 Z M12.2195 11.3758939 L12.3160508 11.4210473 L12.3862841 11.4515241 L12.4524598 11.4763325 L12.6060954 11.5271701 C15.7181185 12.5814838 17.9287911 15.3815586 18.2253797 18.6617294 L18.2303485 18.7226591 L1.62472727 18.7226591 L1.63186903 18.6194555 C1.89896521 14.9658358 4.01389305 12.2812047 7.36508957 11.5034437 C7.37943487 11.5001616 7.40301495 11.4971479 7.43278091 11.4945176 L7.53758757 11.4878927 L7.66121624 11.4842601 C7.78815813 11.4823539 7.91589303 11.4859726 7.96210094 11.498226 C9.52882457 11.9148248 10.4084357 11.9133611 12.0448312 11.428905 L12.2195 11.3758939 Z',
      'M9.90579545 0.655015152 L10.008945 0.655965138 C13.0280483 0.711283206 15.4578788 3.17538632 15.4578788 6.20740909 C15.4578788 9.27389524 12.9721807 11.759803 9.90579545 11.759803 C6.8394102 11.759803 4.35371212 9.27389524 4.35371212 6.20740909 C4.35371212 3.17537784 6.78386563 0.710951544 9.80265679 0.655953962 L9.90579545 0.655015152 Z M9.90579545 2.04342424 C7.60608874 2.04342424 5.74181061 3.90761599 5.74181061 6.20740909 C5.74181061 8.5072711 7.60615765 10.3717045 9.90579545 10.3717045 C12.2056318 10.3717045 14.0697803 8.50738322 14.0697803 6.20740909 C14.0697803 3.90750388 12.2057007 2.04342424 9.90579545 2.04342424 Z',
    ],
  },
  phone: {
    width: 12,
    height: 20,
    paths: [
      'M9.505 0H1.98C.891 0 0 .891 0 1.98v15.445c0 1.089.891 1.98 1.98 1.98h7.525c1.089 0 1.98-.892 1.98-1.98V1.98c0-1.088-.891-1.98-1.98-1.98ZM5.742 18.615c-.765 0-1.386-.443-1.386-.99 0-.547.621-.99 1.386-.99.766 0 1.386.443 1.386.99 0 .547-.62.99-1.386.99Zm4.159-2.971H1.584V2.575h8.317v13.069Z',
    ],
  },
  paper: {
    width: 13,
    height: 18,
    paths: [
      'M12.876 6.642C12.876 2.98 9.988 0 6.438 0S0 2.98 0 6.642c0 3.484 2.614 6.348 5.925 6.618v3.526H4.547v1.059H8.33v-1.059H6.95V13.26c3.311-.27 5.925-3.134 5.925-6.618zM3.544 8.484l.735-.739 1.646 1.743V5.66h1.026v1.981L8.598 5.9l.735.739-2.382 2.52v4.06H5.925v-2.215l-2.381-2.52z',
    ],
  },
  marker: {
    width: 20,
    height: 18,
    paths: [
      'M8.417 0h-.891c-.218 0-.396.178-.396.396v3.762H3.629c-.164 0-.366.037-.562.097-.196.06-.383.143-.516.234L.199 6.103C.066 6.194 0 6.314 0 6.434c0 .12.066.24.199.332L2.551 8.38c.133.091.32.174.516.234.196.06.398.097.562.097H7.13v8.713c0 .218.178.396.396.396h.891c.218 0 .396-.179.396-.396V.395C8.813.179 8.634 0 8.417 0Zm11.187 4.124L17.252 2.51c-.133-.091-.32-.174-.516-.234-.195-.06-.398-.097-.562-.097H9.406l.792 4.554h5.976c.163 0 .366-.038.562-.097.195-.061.383-.143.516-.234l2.352-1.614c.133-.091.199-.211.199-.332 0-.12-.067-.24-.199-.332Z',
    ],
  },
  mail: {
    width: 18,
    height: 12,
    paths: [
      'M.7649998 1.075c.483.26 7.177 3.855 7.426 3.989.249.134.572.198.897.198.325 0 .647-.064.897-.198.249-.134 6.942-3.729 7.425-3.989.484-.26.941-1.075.053-1.075h-16.751c-.888 0-.431.815.053 1.075Zm16.85 1.98c-.549.287-7.294 3.813-7.63 3.989-.336.176-.572.199-.897.199-.326 0-.561-.023-.897-.199-.336-.175-7.081-3.702-7.63-3.989-.387-.202-.383.035-.383.217v7.263c0 .415.553.949.982.949h15.858c.429 0 .982-.534.982-.949V3.272c0-.182.002-.419-.385-.217Z',
    ],
  },
  key: {
    width: 16,
    height: 20,
    paths: [
      'M15.3382383 4.4812858c-.498-2.949-3.188-4.918-6.01-4.398-2.821.52-5.202 2.789-4.705 5.737.107.635.404 1.629.755 2.342l-5.124 7.647c-.188.282-.296.79-.239 1.129l.329 1.951c.057.339.369.567.693.507l1.501-.277c.325-.06.736-.345.915-.634l2.026-3.277.017-.021 1.372-.253 2.366-3.84c.778.137 1.894.091 2.553-.031 2.824-.519 4.049-3.633 3.551-6.582Zm-2.499 1.512c-.776 1.158-1.568.341-2.677-.47-1.108-.811-2.113-1.31-1.337-2.467.776-1.159 2.304-1.44 3.412-.629 1.108.81 1.378 2.407.602 3.566Z',
    ],
  },
  house: {
    width: 22,
    height: 17,
    paths: [
      'M10.8438 4.48828L4.375 9.83203V15.5625C4.375 15.8789 4.62109 16.125 4.9375 16.125H8.875C9.15625 16.125 9.40234 15.8789 9.40234 15.5625V12.1875C9.40234 11.9062 9.68359 11.625 9.96484 11.625H12.2148C12.5312 11.625 12.7773 11.9062 12.7773 12.1875V15.5625C12.7773 15.8789 13.0586 16.125 13.3398 16.125H17.3125C17.5938 16.125 17.875 15.8789 17.875 15.5625V9.79688L11.3711 4.48828C11.3008 4.41797 11.1953 4.38281 11.125 4.38281C11.0195 4.38281 10.9141 4.41797 10.8438 4.48828ZM21.0742 8.10938L18.1562 5.68359V0.832031C18.1562 0.585938 17.9453 0.410156 17.7344 0.410156H15.7656C15.5195 0.410156 15.3438 0.585938 15.3438 0.832031V3.36328L12.1797 0.761719C11.9336 0.550781 11.4414 0.410156 11.0898 0.410156C10.7734 0.410156 10.2812 0.550781 10.0352 0.761719L1.14062 8.10938C1.03516 8.17969 0.964844 8.32031 0.964844 8.42578C0.964844 8.53125 1.03516 8.63672 1.07031 8.70703L1.98438 9.79688C2.05469 9.86719 2.19531 9.9375 2.30078 9.9375C2.37109 9.9375 2.51172 9.90234 2.58203 9.83203L10.8438 3.04688C10.9141 2.97656 11.0195 2.94141 11.125 2.94141C11.1953 2.94141 11.3008 2.97656 11.3711 3.04688L19.6328 9.83203C19.7031 9.90234 19.8438 9.9375 19.9141 9.9375C20.0195 9.9375 20.1602 9.86719 20.2305 9.79688L21.1445 8.70703C21.1797 8.63672 21.25 8.53125 21.25 8.42578C21.25 8.32031 21.1797 8.17969 21.0742 8.10938Z',
    ],
  },
  fingerprint: {
    width: 57,
    height: 63,
    paths: [
      'M28.8454 15.595c13.435131 0 24.3825 10.7092047 24.3825 23.9005 0 5.0303675-4.0697053 9.1095-9.0925 9.1095-5.4865287 0-9.4598707-3.3598328-9.9890887-8.7900034l-.0254392-.2982366C33.9047184 36.5662238 31.729 34.354 28.8454 34.354c-3.7225693 0-6.3645 2.3738405-6.3645 5.5755 0 7.7243906 6.2916426 16.0282933 14.8393756 18.5873766 1.1822337.3539458 1.8536937 1.5992653 1.4997478 2.781499-.3539458 1.1822337-1.5992653 1.8536937-2.781499 1.4997478C25.6137863 59.6770886 18.0119 49.6438862 18.0119 39.9295c0-5.782756 4.7430451-10.0445 10.8335-10.0445 5.2220802 0 9.2068518 3.9568141 9.7086248 9.0275487l.0239017.2776731C38.812385 42.3902629 40.8259895 44.136 44.1354 44.136c2.5523165 0 4.6235-2.0759813 4.6235-4.6405 0-10.7008662-8.9247962-19.4315-19.9135-19.4315-11.6809992 0-20.7625 8.7275478-20.7625 19.8655 0 3.668348.49298555 6.9325169 1.43506888 9.8821583.37546622 1.1755761-.27315103 2.4329444-1.44872716 2.8084106-1.17557613.3754662-2.43294439-.273151-2.8084106-1.4487272C4.17614526 47.7752151 3.6139 44.0524619 3.6139 39.9295c0-13.646736 11.1212152-24.3345 25.2315-24.3345Zm.001 6.875c9.1996362 0 17.0764653 7.4749465 17.5050761 16.6694496.0574655 1.2327416-.8952841 2.2786611-2.1280257 2.3361265-1.2327416.0574655-2.2786611-.8952841-2.3361265-2.1280257C41.5701413 32.5433893 35.6644379 26.939 28.8464 26.939c-7.6372449 0-13.9045 5.802955-13.9045 12.9895 0 7.5513994 2.3396325 12.4446565 7.7301506 17.7317387.8810385.8641327.8947434 2.2788735.0306107 3.1599119-.8641327.8810385-2.2788735.8947434-3.1599119.0306107C13.3437811 54.7707419 10.4729 48.7663976 10.4729 39.9285c0-9.7348215 8.3416576-17.4585 18.3735-17.4585Zm1.7827653 17.2985144c.5579732 7.7731433 6.3881778 13.2260714 16.9378412 12.1372915 1.22756-.1266905 2.325397.7657405 2.4520876 1.9933006.1266905 1.22756-.7657405 2.325397-1.9933006 2.4520876-13.1735435 1.3595778-21.1228888-6.0753599-21.8541588-16.2627085-.0883576-1.2309131.8378666-2.3003933 2.0687797-2.3887509 1.2309131-.0883576 2.3003933.8378666 2.3887509 2.0687797ZM28.8344 7.565c11.0968148 0 21.2638245 5.5830604 27.1978807 14.6211183.6773119 1.031602.390103 2.4169505-.641499 3.0942624-1.031602.6773119-2.4169505.390103-3.0942624-.641499C47.1820537 16.8491279 38.4134844 12.034 28.8344 12.034c-10.0463911 0-18.98035718 4.7658535-24.20032759 12.6157908-.68333682 1.027621-2.07034218 1.3067184-3.09796318.6233816-1.027621-.6833368-1.30671846-2.0703422-.62338164-3.0979632C6.96291612 13.0767668 17.2951551 7.565 28.8344 7.565Zm0-7.237c6.6432881 0 13.0068314 1.53588652 18.3744575 4.36354364 1.0918429.57518113 1.51068 1.92657106.9354989 3.01841391-.5751812 1.09184284-1.9265711 1.51067993-3.0184139.93549881C40.4082587 6.16018788 34.760247 4.797 28.8344 4.797c-6.3908286 0-12.3679767 1.43088495-17.2697516 4.04426752-1.0889772.58058843-2.44242748.16845797-3.02301592-.92051916-.58058843-1.08897714-.16845797-2.44242744.92051916-3.02301588C15.0250048 1.93189591 21.724861.328 28.8344.328Z',
    ],
  },
  bolt: {
    width: 10,
    height: 16,
    paths: [
      'M0.646282233,8.63548612 L0.630890388,8.66262511 C0.478142353,8.95430209 0.688727546,9.31182022 1.02535893,9.31182022 L3.71294554,9.31162134 L3.71294554,15.110114 C3.71294554,15.5576134 4.29970614,15.7245095 4.53522214,15.3439992 L9.5130299,7.30162477 L9.52860412,7.27448618 C9.68324371,6.98275351 9.47278143,6.62333865 9.13515424,6.62333865 L6.3507123,6.62313977 L6.3507123,0.889880223 C6.3507123,0.441179848 5.76141158,0.275202804 5.52723465,0.657947077 L0.646282233,8.63548612 Z M5.46191039,2.46750857 L5.46191039,7.0677396 L5.46302612,7.09947693 C5.47929961,7.33010064 5.67154652,7.51214055 5.90631134,7.51214055 L8.33734068,7.51194167 L4.60174744,13.5474018 L4.60174744,8.86741927 L4.60063171,8.83568194 C4.58435823,8.60505823 4.39211131,8.42301832 4.15734649,8.42301832 L1.81820046,8.42281943 L5.46191039,2.46750857 Z',
    ],
  },
  arrowleft: {
    width: 16,
    height: 16,
    paths: ['m8 16 1.4-1.4L3.8 9H16V7H3.8l5.6-5.6L8 0 0 8z'],
  },
  arrowright: {
    width: 16,
    height: 16,
    paths: ['M8 0 6.6 1.4 12.2 7H0v2h12.2l-5.6 5.6L8 16l8-8z'],
  },
  chevron: {
    width: 14,
    height: 20,
    paths: [
      'M.3.3c.4-.4.9-.4 1.3 0l9.2 9c.1.2.2.4.2.7 0 .3-.1.5-.3.7l-9.2 9c-.4.4-1 .4-1.3 0-.4-.4-.3-1 0-1.3L8.7 10 .3 1.6C-.1 1.3-.1.7.3.3z',
    ],
  },
  'pen-note': {
    width: 512,
    height: 512,
    paths: [
      'M373.1 24.97C401.2-3.147 446.8-3.147 474.9 24.97L487 37.09C515.1 65.21 515.1 110.8 487 138.9L289.8 336.2C281.1 344.8 270.4 351.1 258.6 354.5L158.6 383.1C150.2 385.5 141.2 383.1 135 376.1C128.9 370.8 126.5 361.8 128.9 353.4L157.5 253.4C160.9 241.6 167.2 230.9 175.8 222.2L373.1 24.97zM440.1 58.91C431.6 49.54 416.4 49.54 407 58.91L377.9 88L424 134.1L453.1 104.1C462.5 95.6 462.5 80.4 453.1 71.03L440.1 58.91zM203.7 266.6L186.9 325.1L245.4 308.3C249.4 307.2 252.9 305.1 255.8 302.2L390.1 168L344 121.9L209.8 256.2C206.9 259.1 204.8 262.6 203.7 266.6zM200 64C213.3 64 224 74.75 224 88C224 101.3 213.3 112 200 112H88C65.91 112 48 129.9 48 152V424C48 446.1 65.91 464 88 464H360C382.1 464 400 446.1 400 424V312C400 298.7 410.7 288 424 288C437.3 288 448 298.7 448 312V424C448 472.6 408.6 512 360 512H88C39.4 512 0 472.6 0 424V152C0 103.4 39.4 64 88 64H200z',
    ],
  },
  plus: {
    width: 18,
    height: 18,
    paths: [
      'M10 10H17V8L10 8L10 1.00001L8.00003 1.00001L8.00003 8L1 8L1 10L8.00003 10L8.00003 17L10 17L10 10Z',
    ],
  },
}

// <Icons /> renders paths only, to be <use>d in <Icon id="foo" />
export const SvgPaths = () => (
  <svg style={{ display: 'none' }}>
    {Object.entries(svgs).map(([key, value]) =>
      key && value ? (
        <symbol
          id={`orkusalan-svg-${key}`}
          key={key}
          viewBox={`0 0 ${value.width} ${value.height}`}
        >
          {value.paths.map((path, j) => (
            <path key={j} d={path} />
          ))}
        </symbol>
      ) : null
    )}
  </svg>
)

// render individual icon <Svg id="foo" />
export const Svg = ({
  id,
  constrain = true,
  className,
  width,
  height,
  ...props
}: SVGProps) => {
  if (!id || !svgs[id]) {
    return null
  }

  return (
    <svg
      className={className}
      width={!width ? (constrain ? svgs[id]?.width : undefined) : width}
      height={!height ? (constrain ? svgs[id]?.height : undefined) : height}
      fill="currentColor"
      {...props}
    >
      <use href={`#orkusalan-svg-${id}`} />
    </svg>
  )
}
